export default __webpack_public_path__ + "static/Ammo_Box-976e5b35f6199584842265bfa9f8b908.jpg";